import { connect } from 'react-redux'
import requestPositionSubCard from '../sagas/requestPositionSubCard'
import requestConvertChecklistItemToSubCard from '../sagas/requestConvertChecklistItemToSubCard'
import subCardGroupSelector from './subCardGroupSelector'
import SubCardGroup from './SubCardGroup'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  subCardGroupSelector,
  {
    requestPositionSubCard,
    requestConvertChecklistItemToSubCard
  },
  null,
  {
    forwardRef: true,
  }
)(SubCardGroup))
